module.exports = __webpack_public_path__ + "img/3ne.4e27a01f.svg";